export class Filter {
  id: string;
  filters: string;
}
